import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import router from './router'
import './styles/index.scss'
import 'animate.css' 
import i18n from './i18n'
import vue3SeamlessScroll from "vue3-seamless-scroll";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus)
app.use(vue3SeamlessScroll);
app.use(i18n)
app.use(router)
app.mount('#app')
